<template>
  <div class="row rowcorrect rowEqual" v-if="checkRoles('configuration', 'FinancialReportList')">
    <div class="col-lg-12 col-xs-12">
      <b-card>
        <h6 class="card-title mt-0">{{$t('views.reports.emptyPaymentsMades.showall')}}</h6>
        <b-card-body>
          <b-table
            striped hover
            :borderless="true"
            :items="rowsData"
            :fields="columns"
          >
            <template v-slot:cell(paymentDate)="data">
              <router-link :to="{ name: 'EXSBPaymentsMadeUpdate', params: { id: '/core/public/index.php/api/e_x_s_b_payments_mades/' + data.item.id }}">
                {{ data.item.paymentDate }}
              </router-link>
            </template>
            <template v-slot:cell(value)="data">
              <router-link :to="{ name: 'EXSBPaymentsMadeUpdate', params: { id: '/core/public/index.php/api/e_x_s_b_payments_mades/' + data.item.id }}">
                {{ data.item.value }}
              </router-link>
            </template>
          </b-table>
          <div class="form-group pb-2 col-sm-12">
            <div class="float-right">
              <b-button v-if="downloadXlsStatus === 0" variant="info" @click="downloadXLS()" v-b-tooltip.hover :title="$t('buttons.downloadXLS')" class="float-left ml-2 mr-2 btn-circle">
                <i class="fal fa-file-spreadsheet"></i>
              </b-button>
              <b-button v-if="downloadXlsStatus === 1" variant="success" v-b-tooltip.hover :title="$t('buttons.downloadXLS')" class="float-left ml-2 mr-2 btn-circle">
                <i class="fal fa-spinner fa-spin"></i>
              </b-button>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import { checkPagePermission, checkPermission } from '@/utils/checkRoles'
import ApiService from '@/utils/ApiService'

export default {
  name: 'emptyPaymentsMades',
  data () {
    return {
      tabIndex: 0,
      rowsData: [],
      downloadXlsStatus: 0,
      columns: [
        { key: 'paymentDate', label: this.$t('views.exsbpaymentsmade.form.paymentDate') },
        { key: 'description', label: this.$t('global.description') },
        { key: 'payer', label: this.$t('tableHeadings.payer') },
        { key: 'fromAccount', label: this.$t('views.exsbpaymentsmade.edit.account') },
        { key: 'account', label: this.$t('global.accountMassCollect') },
        { key: 'value', label: this.$t('tableHeadings.valueSingle') }
      ]
    }
  },
  beforeCreate () {
    checkPagePermission('configuration', 'FinancialReportList')
  },
  created () {
    this.fetchData()
  },
  destroyed () {
  },
  methods: {
    async downloadXLS () {
      this.downloadXlsStatus = 1
      let params = {
        xls: 1
      }
      await new ApiService('reports/emptypaymentsmades', params).downloadFile('empty_paymentsmades_.xls')
      this.downloadXlsStatus = 0
    },
    async fetchData () {
      this.rowsData = await new ApiService('reports/emptypaymentsmades').getResults()
      for (let j in this.rowsData) {
        this.rowsData[j].value = this.rowsData[j].value + ' ' + this.$t('currency')
        if (this.rowsData[j].paymentDate) {
          this.rowsData[j].paymentDate = this.$moment(this.rowsData[j].paymentDate.date).format('YYYY-MM-DD HH:mm')
        }
      }
    },
    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    }
  }
}
</script>
